import {
  VehicleSeriesDefinitionContextType,
  VehicleSeriesDefinitionFormWrapperProps,
} from '../types';
import {useVehicleSeriesDefinitionSelectors} from '../utils';
import {VehicleSeriesDefinitionForm} from './VehicleSeriesDefinitionForm';

type VehicleSeriesDefinitionFormWithListsProps = VehicleSeriesDefinitionFormWrapperProps &
  Pick<VehicleSeriesDefinitionContextType, 'isSystem'>;

export const VehicleSeriesDefinitionFormWithLists = (
  props: VehicleSeriesDefinitionFormWithListsProps
) => {
  const {branchList, seriesList, vehicleTypes} = useVehicleSeriesDefinitionSelectors();

  return (
    <VehicleSeriesDefinitionForm
      branchList={branchList}
      seriesList={seriesList}
      vehicleTypes={vehicleTypes}
      {...props}
    />
  );
};
